import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { IDocumentEngineTemplate } from '@core/entities/document-engine'
import { RequestTypes } from '../requestTypes'
import { documentEngineTemplateKeys } from '../documentEngineTemplateKeys'
import { documentEngineTemplatesKeys } from '../../documentEngineTemplatesKeys'

export const useUpdateDocumentEngineTemplateQueries = (
  options?: UseMutationOptions<
    IDocumentEngineTemplate,
    RequestErrorType,
    RequestTypes['updateDocumentEngineTemplateQueries']
  >,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...documentEngineTemplateKeys.updateDocumentEngineTemplateQueries,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: documentEngineTemplatesKeys.byOrganisation({
          organisationId: variables.organisationId,
        }).queryKey,
      })
    },
    ...options,
  })
}
